import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-chargement',
  templateUrl: './chargement.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './chargement.component.scss',
})
export class ChargementComponent {}
